import * as React from 'react';
import { Modal, ModalFooter } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { useBaseSummarySlot } from '../../slots/summaries/summary-context.js';
import { updateShippingDetails } from '../../StepShipping/actions.js';
import { CompanyFormContainer } from '../../StepShipping/containers/CompanyFormContainer.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '../../slots/forms/form-context.js';
import '../../slots/summaries/types.js';
import '../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { getShippingData } from '../../StepShipping/selectors.js';

const EditableCompanySummary = ({ labels  })=>{
    var ref, ref1;
    const [companyFormData, setCompanyFormData] = React.useState();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { Slots  } = useBaseSummarySlot();
    const dispatch = useDispatch();
    const companyData = (ref = useSelector(getShippingData)) === null || ref === void 0 ? void 0 : ref.company;
    const hasData = companyData && !Object.values(companyData).every((x)=>x === null || x === ''
    );
    const CompanySummarySlot = Slots.company;
    if (!CompanySummarySlot && hasData) {
        console.error('This opco is misconfigured. It has company data, but no company summary card setup.');
    }
    if (!CompanySummarySlot || !hasData) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        footer: /*#__PURE__*/ React.createElement(ModalFooter, {
            ctaCaption: labels === null || labels === void 0 ? void 0 : (ref1 = labels.editModal) === null || ref1 === void 0 ? void 0 : ref1.save,
            onCta: ()=>{
                if (!(companyFormData === null || companyFormData === void 0 ? void 0 : companyFormData.formValid)) {
                    Util.focusToTopErrorFieldOnScreen();
                } else {
                    companyFormData && dispatch(updateShippingDetails({
                        form: companyFormData
                    }));
                    setIsModalOpen(false);
                }
            },
            onCancel: ()=>setIsModalOpen(false)
        })
    }, /*#__PURE__*/ React.createElement(CompanyFormContainer, {
        onChange: (formData)=>setCompanyFormData(formData)
    })), /*#__PURE__*/ React.createElement(CompanySummarySlot, {
        actions: {
            onEdit: ()=>setIsModalOpen(true)
        },
        values: companyData
    }));
};

export { EditableCompanySummary, EditableCompanySummary as default };
//# sourceMappingURL=EditableCompanySummary.js.map
